import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routes'
import store from '@/store'

Vue.use(VueRouter)

export const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.authRequired) && !store.getters['auth/isLoggedIn']) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: 'auth.login'
    })
  } else if (to.matched.some(m => m.meta.guestOnly) && store.getters['auth/isLoggedIn']) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: 'dashboard.index'
    })
  } else {
    next()
  }
})

Vue.router = router

export default router
